// extracted by mini-css-extract-plugin
export default {"main":"Reviews_main__0W55b","top-heading":"Reviews_top-heading__yU99B"};